<div class="container-fluid">
    <div class="card">
        <div class="card-body">
            <div [hidden]="!hasRouteAccess(routes.SECURE.ACCOUNT.ECOMMERCE)" class="form-group">
                <div [hidden]="isResultListEmpty()" class="margin-top-bottom">
                    <h3>
                        <i class="fa fa-info-circle"></i> No ecommerce payments found. </h3>
                </div>
                <app-search-view>
                    <app-payment-search #app
                                        [autoRefresh]="true"
                                        [ecommerceStoreOptions]="ecommerceStoreOptions"
                                        [showBatchFilter]="false"
                                        [showEcommerceStoreFilter]="true"
                                        [showCsvExport]="true"
                                        [csvPeriodOptions]="periodOptions"
                                        [csvSelectedPeriod]="selectedPeriod"
                                        [csvDownloading]="csvDownloading"
                                        (csvPeriodChange)="onPeriodChange($event)"
                                        (csvDownload)="downloadCsv()"
                                        filters></app-payment-search>
                    <div grid>
                        <app-ecommerce-account-table
                            [accounts]="contents"
                            [sortField]="searchService.field ?? null"
                            [sortOrder]="(searchService.direction === 'ASC' ? 'ASC' : 'DESC')"
                            [storesById]="storesById"
                            [menuItemsForAccount]="buildMenuItemsForAccount"
                            [clickable]="true"
                            [isExpanded]="isAccountExpanded"
                            (sortChange)="onSortChange($event, app)"
                            (rowClick)="onRowClick($event)">

                            <ng-template #expandedRow let-account>
                                <td class="events-cell" colspan="10">
                                    <div class="events-container">
                                        <div class="events-title">Payment Events</div>
                                        <table class="table events-table">
                                            <thead>
                                            <tr>
                                                <th scope="col">Date</th>
                                                <th scope="col">Type</th>
                                                <th scope="col">Network</th>
                                                <th scope="col">Tender Type</th>
                                                <th scope="col">Error Code</th>
                                                <th scope="col">Network Error Code</th>
                                                <th scope="col">Network Error Message</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                                @if (isPaymentEventsLoading(account?.id)) {
                                                    <tr>
                                                        <td class="events-empty" colspan="7">Loading events...</td>
                                                    </tr>
                                                } @else if (hasPaymentEventsError(account?.id)) {
                                                    <tr>
                                                        <td class="events-empty" colspan="7">Failed to load events.</td>
                                                    </tr>
                                                } @else if ((getPaymentEvents(account)?.length ?? 0) === 0) {
                                                    <tr>
                                                        <td class="events-empty" colspan="7">No events available.</td>
                                                    </tr>
                                                }
                                                @for (event of getPaymentEvents(account); track event.eventId ?? $index) {
                                                    <tr>
                                                        <td>
                                                            <span class="p-column-title">Date</span>
                                                            @if (event?.timestamp) {
                                                                {{ event?.timestamp | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD HH:mm:ss' }}
                                                            } @else {
                                                                -
                                                            }
                                                        </td>
                                                        <td>
                                                            <span class="p-column-title">Type</span>
                                                            {{ event?.type ?? '-' }}
                                                        </td>
                                                        <td>
                                                            <span class="p-column-title">Network</span>
                                                            {{ event?.networkName ?? '-' }}
                                                        </td>
                                                        <td>
                                                            <span class="p-column-title">Tender Type</span>
                                                            @if (event?.tenderTypes?.length) {
                                                                @for (tender of event.tenderTypes; track tender) {
                                                                    <div>{{ tender }}</div>
                                                                }
                                                            } @else {
                                                                -
                                                            }
                                                        </td>
                                                        <td>
                                                            <span class="p-column-title">Error Code</span>
                                                            {{ event?.errorCode ?? '-' }}
                                                        </td>
                                                        <td>
                                                            <span class="p-column-title">Network Error Code</span>
                                                            {{ event?.networkErrorCode ?? '-' }}
                                                        </td>
                                                        <td>
                                                            <span class="p-column-title">Network Error Message</span>
                                                            {{ event?.networkErrorMessage ?? '-' }}
                                                        </td>
                                                    </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                            </ng-template>
                        </app-ecommerce-account-table>
                    </div>
                </app-search-view>
            </div>
        </div>
    </div>
</div>
